export default ".header_text {\n  color: #18406e;\n}";